<template>
  <div class="management-contract">
    <el-form ref="form" :model="filtersForm" label-width="80px" inline>
      <el-form-item label="患者姓名">
        <el-input v-model="filtersForm.patName" placeholder="请输入患者姓名"></el-input>
      </el-form-item>
      <el-form-item label="申请日期">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-radio-group v-model="checkedStatus">
      <el-radio-button v-for="state in states" :label="state.label" :key="state.text">{{state.text}}</el-radio-button>
    </el-radio-group>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="createTime" :formatter="formatterCreateTime" label="申请日期" width="180"></el-table-column>
      <el-table-column prop="status" :formatter="formatterStatus" label="当前状态"></el-table-column>
      <el-table-column prop="patName" label="患者姓名"></el-table-column>
      <el-table-column prop="patGender" :formatter="formatterSex" label="性别"></el-table-column>
      <el-table-column prop="patAge" label="年龄"></el-table-column>
      <el-table-column prop="patMobile" label="电话"></el-table-column>
      <el-table-column prop="areaName" label="地区"></el-table-column>
      <el-table-column prop="hosName" label="申请签约机构"></el-table-column>
      <el-table-column prop="docName" label="申请医生"></el-table-column>
      <el-table-column v-if="checkedStatus === ''" label="取消原因">
        <template slot-scope="scope">
          <span :title="scope.row.cancelReason">{{scope.row.cancelReason}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click.prevent="goToDetails(scope.row.id)" type="primary" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-wrapper" type="flex" justify="end">
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="page.pageNum"
        :total="page.total"
        @current-change="onCurrentChange"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { timeFormat, sex } from "ty-vue-filters";
const PAGE = {
  pageNum: 1,
  pageSize: 10,
  pages: 1,
  total: 0
};
export default {
  data() {
    return {
      daterange: [],
      filtersForm: {
        patName: "",
        startDate: "",
        endDate: ""
      },
      list: [],
      states: [
        {
          label: "WAITCONTRACT",
          text: "待签约"
        },
        {
          label: "CONTRACT",
          text: "已签约"
        },
        {
          label: "",
          text: "全部"
        }
      ],
      loading: false,
      page: PAGE,
      checkedStatus: "WAITCONTRACT"
    };
  },
  watch: {
    daterange(val) {
      this.filtersForm.startDate = val ? val[0] : "";
      this.filtersForm.endDate = val ? val[1] : "";
    },
    checkedStatus: {
      handler() {
        this.pages = PAGE;
        this.getList();
      },
      immediate: true
    }
  },
  methods: {
    goToDetails(id) {
      this.$router.push({
        path: "/main/management-contract-details",
        query: { id }
      });
    },
    onSubmit() {
      this.getList();
    },
    onCurrentChange(pageNum) {
      this.page.pageNum = pageNum;
      this.getList();
    },
    getList() {
      this.loading = true;
      axiosUtil(
        {
          status: this.checkedStatus,
          service: "smarthos.contract.doc.list",
          token: localStorage.getItem("token"),
          ...this.page,
          ...this.filtersForm
        },
        ({ code, list, page, msg }) => {
          if (code === "0") {
            this.loading = false;
            this.list = list;
            this.page = page;
          } else {
            this.$message.error(msg);
          }
        }
      );
    },
    formatterCreateTime(row, column, createTime) {
      return timeFormat(createTime, "%Y-%m-%d %H:%M:%S");
    },
    formatterStatus(row, column, code) {
      const statusObj = {
        WAITCONTRACT: "待签约",
        CONTRACT: "已签约",
        CANCEL: "已取消",
        REFUSE: "已拒绝",
        OVERDUE: "已过期"
      };
      return statusObj[code];
    },
    formatterSex(row, column, code) {
      return sex(code, 2);
    }
  }
};
</script>

<style lang="scss">
.management-contract {
  .el-table {
    margin-top: 15px;
  }
  .pagination-wrapper {
    padding: 20px 0;
  }
  .el-table .cell {
    max-height: 69px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
